import { SCHOOL_LIST_FAILURE, SCHOOL_LIST_SUCCESS } from "./masterData.actionTypes";

const initialState = {
  schoolList: null,
  message: null
};

export default function MasterDataReducer(state = initialState, { type, payload }) {
  switch (type) {
    case SCHOOL_LIST_SUCCESS:
      return {
        ...state,
        schoolList: payload,
      };
    case SCHOOL_LIST_FAILURE:
      return {
        ...state,
        message: "",
      };

    default:
      return state;
  }
}
